module.exports = require("detect-node");